import React from "react";
import R from "ramda";
import startCase from "lodash/startCase"
import styled from "styled-components";
import { compose, lifecycle, withState, withHandlers, withPropsOnChange, } from "recompose";
import { connect, } from "react-redux";
import * as contentful from "contentful-management";

import * as m from "src/components/style/mixins";
import * as v from "src/components/style/vars";
import * as consts from "src/consts";
import { plog, } from "src/lib/util";

import {
	GridCell,
	Button,
} from "src/components/common";

import Field from "./Field";
import Topbar from "src/components/Editor/Topbar";

// --------------------------------------------------

const Wrapper = styled(GridCell)`
	position: relative;
	margin-top: ${v.dim.nav.height};
	${p => p.updating ? "opacity: 0.5;": ""}
`;

const UpdatingOverlay = styled.div`
	${m.contained()}
`;

const SaveButtonWrapper = styled(GridCell)`
	margin-top: 5em;
`;

// --------------------------------------------------

const pagesMap = {
	about: "pageAbout",
	classes: "pageClasses",
	test: "pageTest",
	home: "pageHome",
	siteSettings: "siteSettings"
};

const enhance = compose(
	connect(R.identity),
	withState("entry", "setEntry", null),
	withState("fieldTypes", "setFieldTypes", null),
	withState("updating", "setUpdating", false),
	withState("invalidUrl", "setInvalidUrl", false),
	withPropsOnChange([ "match", ], R.path([ "match", "params", ])),
	withHandlers({
		saveChanges: ({ entry, setEntry, setUpdating, dispatch, page, }) => () => {
			return entry.update()
			.then(plog("entry.update()"))
			.then(updatedEntry => {
				plog("entry.update()")(updatedEntry);
				setEntry(
					updatedEntry
				);
				return updatedEntry;
			})
			.then(entry => {
				return entry.publish()
			})
		},
		getData: props => () => {
			props.setEntry(null);
			props.setFieldTypes(null);
			props.setInvalidUrl(false);
			const contentType = pagesMap[props.page];
			console.log("contentType", contentType, props);
			console.log("componentDidMount");
			if (contentType) {
				props.space.getEntries({ "content_type": contentType, })
				.then(entries => {
					props.setEntry(entries.items[0]);
				})

				props.space.getContentType(contentType)
				.then(t => t.getEditorInterface())
				.then(plog("editor interface"))
				.then(ei => {
					const fieldTypes = ei.controls.reduce((acc, o) => ({
						...acc,
						[o.fieldId]: {
							name: o.fieldId,
							type: o.widgetId,
							setContent: newContent => {
								props.setEntry(entry => {
									entry.fields[o.fieldId] = {
										[consts.lang]: newContent,
									};
									return entry;
								});
							},
						},
					}), {});
					props.setFieldTypes(fieldTypes);
				})
			}
			else {
				props.setInvalidUrl(true);
			}		
		},
	}),
	lifecycle({
		componentDidMount() {
			this.props.getData();	
		},
		componentDidUpdate(prevProps) {
			if (this.props.match.params.page !== prevProps.match.params.page) {
				this.props.getData();
			}
		},
	})
);

const Pages = ({ entry, fieldTypes, saveChanges, updating, invalidUrl, page, }) => (
	<div>
		<Topbar
			title = { page ? page + " page" : "" }
			title = {
				page
				? (
					page === "siteSettings"
					? "site settings"
					: page + " page"
				)
				: ""
			}
			save = { saveChanges }
		/>
		{
			entry && fieldTypes
			? (
				<Wrapper updating = { false }>
					{ console.log("entry fields", entry ? entry.fields : "no entry found, yet") }
					{
						Object.keys(fieldTypes).map(fieldName => (
							<Field
								key = { fieldName }
								name = { fieldName }
								type = { fieldTypes[fieldName].type }
								content = {
									entry.fields[fieldName]
									? entry.fields[fieldName][consts.lang]
									: null
								}
								setContent = { fieldTypes[fieldName].setContent }
							/>
						))
					}
				</Wrapper>
			)
			: (
				invalidUrl
				? <Wrapper>404</Wrapper>
				: <Wrapper>Loading...</Wrapper>
			)			
		}
	</div>	
);

export default enhance(Pages);


// WEBPACK FOOTER //
// ./src/components/Editor/Pages/index.js